import { formatIsoDateToAmerican } from '@helpers/formatIsoDateToAmerican';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import type { JobsReportDTO } from 'app/API';
import { JOB_STATUSES_ENUM } from 'app/types/enums/jobStatuses';

export const JOBS_REPORT_CSV_HEADERS = [
  'ID',
  'Title',
  'Due',
  'Creator',
  'Organization',
  'Workspace',
  'Status',
  'Created',
  'Asr used',
  'Edits %',
];

export type TJobsReportCsvSource = Pick<
  JobsReportDTO,
  | 'id'
  | 'jobName'
  | 'deadline'
  | 'name'
  | 'lastname'
  | 'email'
  | 'status'
  | 'createdAt'
  | 'duration'
  | 'editingProgress'
>;

type TContext = {
  organizationName: string;
  workspaceName: string;
};

export const buildJobsReportCsvRows = (jobs: TJobsReportCsvSource[], { organizationName, workspaceName }: TContext) =>
  jobs.map((job) => ({
    id: job.id,
    title: job.jobName ?? '',
    due: job.deadline ? formatIsoDateToAmerican(job.deadline) : '',
    creator: `${job.name} ${job.lastname} (${job.email})`,
    organization: organizationName,
    workspace: workspaceName,
    status: JOB_STATUSES_ENUM[job.status as keyof typeof JOB_STATUSES_ENUM],
    created: getAmericanTime(job.createdAt),
    asr: job.duration || 0,
    editsPercent: Math.round(job.editingProgress || 0),
  }));
